import * as React from "react";
import { useState } from "react";
import { Button } from "@ssce/ui-shared-library";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./Oracle.css";
import { useNavigate } from "react-router-dom";
import OracleOverView from "./OracleOverView";
import OracleTechnicalSpecifications from "./OracleTechnicalSpecifications";
import OraclePlansAndFeatures from "./OraclePlansAndFeatures";
import OracleImage from "../../../../assets/Oracle.png";
import { MyServicesCardHeader } from "../../MyServices/Cards/CardTemplate/myServicesCardHeader";

const Oracle: React.FC = () => {
  const [value, setValue] = useState("1");

  const navigate = useNavigate();

  const handleChangeTabs = (_, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <MyServicesCardHeader
        imageSource={OracleImage}
        title={"Oracle"}
        contents={
          "Oracle Database 23ai is designed to seamlessly integrate AI capabilities directly into the database, allowing organizations to power AI-driven applications more efficiently and manage mission-critical workloads with enhanced performance. It ensures applications run with high availability, security, and scalability, making it a comprehensive solution for modern data management challenges."
        }
        tags={[
          {
            label: "Data Management",
            style: { backgroundColor: "#E7F3F9", color: "#0A85C7" },
          },
          {
            label: "Analytics",
            style: { backgroundColor: "#EFE6FD", color: "#6200EE" },
          },
          {
            label: "Cross-Industry",
            style: { backgroundColor: "#FFE5F0", color: "#D72F77" },
          },
        ]}
      >
        <Button
          width="12rem"
          id={"createInstance"}
          onClick={() => navigate("/public-catalog/Oracle/provision")}
        >
          Create Instance
        </Button>
        <Button variant="secondary" onClick={() => {}} id={"gettingStarted"}>
          Getting Started
        </Button>
      </MyServicesCardHeader>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            id={"tabs"}
            onChange={handleChangeTabs}
            aria-label="lab API tabs example"
          >
            <Tab label="Overview" value="1" />
            <Tab label="Plans and Features" value="2" />
            <Tab label="Technical Specifications" value="3" />
            <Tab label="Documentation" value="4" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ marginTop: "4.5rem", padding: 0 }}>
          <OracleOverView />
        </TabPanel>
        <TabPanel value="2" sx={{ marginTop: "4.5rem", padding: 0 }}>
          <OraclePlansAndFeatures />
        </TabPanel>
        <TabPanel value="3" sx={{ marginTop: "4.5rem", padding: 0 }}>
          <OracleTechnicalSpecifications />
        </TabPanel>
        <TabPanel
          value="4"
          sx={{ padding: "4.5rem 0 0 0", display: "flex" }}
        ></TabPanel>
      </TabContext>
      <div className="flex-row justifyContent-center gap1rem">
        <Button
          width="12rem"
          id={"createInstance"}
          onClick={() => navigate("/public-catalog/Oracle/provision")}
        >
          Create Instance
        </Button>
        <Button variant="secondary" id={"gettingStarted"} onClick={() => {}}>
          Getting Started
        </Button>
      </div>
    </>
  );
};
export default Oracle;
